import type { UsageForecast } from "./backend";

export type UsageForecastItem = {
  month: number;
  usage: number;
};

export const mapToUsageForecastItemType = (
  data: UsageForecast,
): UsageForecastItem => {
  return {
    month: data.month,
    usage: data.usage,
  };
};
